/* src/components/pdf-page-forecast-end-result-list-table/pdf-page-forecast-end-result-list-table.component.scss */
app-pdf-page-forecast-end-result-list {
  display: block;
}
.table-col--score {
  width: 16mm;
  max-width: 16mm;
}
.table-col--per-costs,
.table-col--best-guess,
.table-col--min-costs,
.table-col--max-costs {
  width: 24mm;
  max-width: 24mm;
  white-space: nowrap;
}
/*# sourceMappingURL=pdf-page-forecast-end-result-list-table.component-44Q73Q7X.css.map */
